import { styled, useStyletron } from "baseui";
import React from "react";
import { CommandIcon } from "../icons/CommandIcon";
import { OptionIcon } from "../icons/OptionIcon";
import { ShiftIcon } from "../icons/ShiftIcon";
import { expandBorderRadii } from "../utils";
import { Row } from "./Row";

export const ShortcutKey = styled<{ $kind: "light" | "dark" }, "div">("div", ({ $theme, $kind }) => ({
  minWidth: $theme.sizing.scale700,
  height: $theme.sizing.scale700,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  backgroundColor: $kind == "dark" ? $theme.colors.alpha700 : $theme.colors.alpha100,
  color: $kind === "dark" ? $theme.colors.contentInversePrimary : $theme.colors.alpha500,
  ...expandBorderRadii($theme.borders.radius200),
  boxShadow: "0px -1px 0px 0px rgba(0, 0, 0, 0.14) inset",
}));

const isMac = typeof navigator !== "undefined" && /Mac|iPod|iPhone|iPad/.test(navigator.platform);

export const ctrlKeyText = () => {
  return isMac ? "^" : "CTRL";
};

export const shortcutKeyText = (key: string) => {
  key = key.toUpperCase();
  if (key == "MOD" || key == "META") {
    if (isMac) {
      return <CommandIcon $size={16} />;
    } else {
      return "CTRL";
    }
  } else if (key == "CTRL") {
    return ctrlKeyText();
  } else if (key == "OPTION") {
    if (isMac) {
      return <OptionIcon $size={16} />;
    } else {
      return "ALT";
    }
  } else if (key == "SHIFT") {
    return <ShiftIcon $size={16} />;
  } else if (key == "ENTER" || key == "RETURN") {
    return "↵";
  } else {
    return key;
  }
};

export const ShortcutKeys = (props: { keys: string[]; $kind: "light" | "dark" }) => {
  const [css, $theme] = useStyletron();

  return (
    <Row $gap={$theme.sizing.scale100}>
      {props.keys.map((key, index) => (
        <ShortcutKey key={index} $kind={props.$kind}>
          {shortcutKeyText(key)}
        </ShortcutKey>
      ))}
    </Row>
  );
};
